import { render, staticRenderFns } from "./OpportunityStatusType.vue?vue&type=template&id=6b8a0d0e&scoped=true"
import script from "./OpportunityStatusType.vue?vue&type=script&lang=js"
export * from "./OpportunityStatusType.vue?vue&type=script&lang=js"
import style0 from "./OpportunityStatusType.vue?vue&type=style&index=0&id=6b8a0d0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a0d0e",
  null
  
)

export default component.exports